import React, { useEffect, useContext, useState, useActionState } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Input_Text_Long from '../ERUMAUI/UI_Input_Text_Long';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Toggle from '../ERUMAUI/UI_Toggle';

export default function Subwindow_ScheduleManagement_Equipment({ zIndex, isActive, id }) {
    const UI = useContext(Context_UI);
    const { Template_List } = useTemplating();
    const { Buildings, Floors, Rooms, Map_Composition } = useMapRenderer();
    const { Reservation, Reservation_Set } = useScheduleManagement();
    const Close = () => {
        UI.Subwindows_Close(id);
    }


    useEffect(() => {
        const Handle_Toggle = ({ ID, State }) => {
            // Extract equipment name from ID: "Item_Equipment_3"
            const index = parseInt(ID.replace("Item_Equipment_", ""));
            const item = Template_List?.Equipment[index];

            Reservation_Set(prev => {
                let updated = [...(prev.Equipment || [])];

                if (State === "Active") {
                    if (!updated.includes(item)) updated.push(item);
                } else {
                    updated = updated.filter(eq => eq !== item);
                }

                return {
                    ...prev,
                    Equipment: updated
                };
            });
        };

        UI.on("Button_Toggled", Handle_Toggle);
        return () => {
            UI.off("Button_Toggled", Handle_Toggle);
        };
    }, [UI, Reservation_Set, Template_List]);

    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    List of equipment
                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Close}>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content style={{ minHeight: "500px", paddingRight: "10px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        {Template_List?.Equipment.map((Item, Index) => (
                            <UI_Toggle
                                key={Index}
                                id={`Item_Equipment_${Index}`}
                                Text={Item}
                                Selected={Reservation.Equipment?.includes(Item) ? "true" : "false"}
                            />
                        ))}
                    </div>
                    
                </div>



            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Close}>
                    Close
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
